<template>
	<div>
		<div style="margin: 10px 0;">
			<van-icon name="passed" color="#ee0a24" size="80" />
			<div>付款成功!</div>
		</div>
		<van-divider />
		<van-cell-group  style="text-align: left;">
		  <van-cell title="订单编号" :value="orderInfo.out_trade_no" />	  
		  <van-cell title="商品数量" :value="orderInfo.item_num" />
		  <van-cell title="支付金额" :value="'￥'+orderInfo.total_fee" />
		  <van-cell title="下单时间" :value="orderInfo.create_time" />
		  <van-cell title="提货日期" :value="orderInfo.pickup_time*1000 | formonment('YYYY-MM-DD')" />
		</van-cell-group>
		<div style="padding: 20px 20px;">
			<van-button type="primary" round size="large" @click="goOrderIng">查看订单信息</van-button>
			<div class="back-index">
				<span style="border-bottom: 1px solid #000;" @click="goIndex">返回首页</span>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		name:"",
		data(){
			return{
				orderInfo:{},
			}
		},
		methods:{
			goIndex(){
				this.$router.push('/')
			},
			goOrderIng(){
				this.$router.replace({
					path:'/orderIng',
					query:{
						id:this.orderInfo.order_id,
					}
				})
			},
		},
		created() {
			this.orderInfo=this.$route.query.order_info
		}
	}
</script>

<style>
	.back-index{
		font-size: 14px;
		color: #666666;
		margin-top: 8px;
		}
</style>
